class GeoLocationComponent extends HTMLElement {
  constructor() {
    super();

    this.sectionId = this.getAttribute('data-section-id');
    this.cookieName = 'geo-location' + this.sectionId;
    this.cookieGET = Cookies.get(this.cookieName);
    this.popup = this.querySelector('.geo-location-wrap');

    // Check if popup exists before accessing its properties
    if (this.popup) {
      this.geoFlags = this.popup.querySelectorAll('.flag-link');
      this.geoUrl = this.popup.querySelector('.geo-url');
    }

    const self = this; // Save a reference to the current instance

    // Get all elements matching the selector
    var closeButtons = document.querySelectorAll('.geo-close-js');
    // Iterate over each element and add an event listener
    closeButtons.forEach(function(button) {
      button.addEventListener('click', function () {
        if (self.popup) {
          self.popup.style.display = 'none';
        }
        Cookies.set(self.cookieName, 'opened', { path: '/', expires: 7 });
      });
    });


    // Check if cookie is not set
    if (!this.cookieGET) {
      this.locationTrack();

      // Add event listeners for flag links
      this.geoFlags.forEach(function (link) {
        link.addEventListener('click', function () {
          self.geoFlags.forEach(function (flagLink) {
            flagLink.classList.remove('active');
          });
          this.classList.add('active');
          self.geoUrl.setAttribute('href', link.getAttribute("data-href"));
        });
      });

      // Add event listeners for buttons
      const buttons = this.querySelectorAll('.js-geo-location');
      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          this.showGeoLocationPopup();
        });
      });
    }
  }

  locationTrack() {
    fetch('https://ipinfo.io?token=e70446683c4309')
      .then(response => response.json())
      .then(data => {
        // Check if popup exists before changing its style
        if (this.popup) {
          if (data.country === "NZ" || data.country === "DE" ) {
            this.popup.style.display = "flex";
          }
        }
      })
      .catch(error => {
        console.error('Error fetching IP information:', error);
      });
  }

  showGeoLocationPopup() {
    if (this.popup) {
      this.popup.style.display = "block";
    }
  }

  hideGeoLocationPopup() {
    if (this.popup) {
      this.popup.style.display = "none";
    }
  }

  setGeoLocationCookie() {
    Cookies.set('gepLocationNZ', 'value', { expires: 14 });
  }

}

customElements.define('geo-location', GeoLocationComponent);

document.querySelector('.header__geo-trigger--button').addEventListener('click', onClickFlag.bind())
function onClickFlag(){
  document.querySelector('.geo-location-wrap').style.display = "flex";
}